export default class Header extends HTMLElement {
  lastScrollY = 0;
  scrollThreshold = 100;
  scrollDelta = 0;
  isAnimating = false;
  animationTimeout = null;
  ticking = false;
  isMenuHidden = false;

  connectedCallback() {
    // Defer layout reads to rAF so they don't force a reflow during HTML parse.
    // --header-height being one frame late is invisible: the server-rendered
    // header already occupies its correct height in the flow.
    // lastScrollY starts at 0 (class field) — correct at page load where
    // window.scrollY is always 0; reading it here would force an extra reflow.
    requestAnimationFrame(() => {
      // All reads first, then all writes (no thrashing).
      const headerHeight = this.offsetHeight;
      const headerBar = window.innerWidth < 1024 ? this.querySelector('[data-header-modal-header]') : null;
      const modal = headerBar ? this.querySelector('[data-header-menu-modal]') : null;
      const headerBarHeight = headerBar ? headerBar.offsetHeight : null;

      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
      if (modal && headerBarHeight !== null) {
        modal.style.setProperty('--menu-header-height', `${headerBarHeight}px`);
      }
    });

    window.addEventListener('scroll', this.handleScroll.bind(this), { passive: true });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.handleScroll.bind(this));
    if (this.animationTimeout) {
      clearTimeout(this.animationTimeout);
    }
  }

  handleScroll() {
    if (!this.ticking) {
      window.requestAnimationFrame(() => {
        this.updateMenuState();
        this.ticking = false;
      });
      this.ticking = true;
    }
  }

  updateMenuState() {
    const currentScrollY = window.scrollY;

    if (currentScrollY <= this.scrollThreshold) {
      this.scrollDelta = 0;
      this.lastScrollY = currentScrollY;
      if (this.isMenuHidden) {
        this.openMenu();
      }
      return;
    }

    const difference = currentScrollY - this.lastScrollY;
    this.lastScrollY = currentScrollY;

    this.scrollDelta += difference;

    const actionThreshold = 60;

    if (this.scrollDelta > actionThreshold) {
      if (!this.isMenuHidden) {
        this.closeMenu();
      }
      this.scrollDelta = 0;
    } else if (this.scrollDelta < -actionThreshold) {
      if (this.isMenuHidden) {
        this.openMenu();
      }
      this.scrollDelta = 0;
    }

    this.scrollDelta = Math.max(-150, Math.min(150, this.scrollDelta));
  }

  closeMenu() {
    if (this.isMenuHidden) return;

    this.isMenuHidden = true;
    this.setAttribute('data-menu-closed', '');
    this.removeAttribute('data-menu-opening');

    if (this.animationTimeout) {
      clearTimeout(this.animationTimeout);
      this.animationTimeout = null;
    }
  }

  openMenu() {
    if (!this.isMenuHidden && !this.isAnimating) return;

    this.isMenuHidden = false;
    this.removeAttribute('data-menu-closed');
    this.setAttribute('data-menu-opening', '');
    this.isAnimating = true;

    if (this.animationTimeout) {
      clearTimeout(this.animationTimeout);
    }

    this.animationTimeout = window.setTimeout(() => {
      this.removeAttribute('data-menu-opening');
      this.isAnimating = false;
      this.animationTimeout = null;
    }, 450);
  }
}
